import Resetpassword from './src/Resetpassword.vue';

Resetpassword.install = function (app) {
  app.component(Resetpassword.name, Resetpassword)
}

export default Resetpassword


//////////////////
// WEBPACK FOOTER
// ./packages/Resetpassword/index.js
// module id = null
// module chunks = 